import React, { useContext } from 'react'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import ControlledModal from 'components/Modal/ControlledModal'
import { AuthContext } from 'components/Auth/Auth'
import AuthLoginConfirm from 'components/Auth/AuthLoginConfirm/AuthLoginConfirm'

const AuthLoginConfirmModal = () => {
    const auth = useContext(AuthContext)

    return (
        <ControlledModal
            name="auth-login-confirm-modal"
            context="authLoginConfirmModal"
            requireUserInput={false}
            closeOnRouteChange={false}
            onClose={async () => {
                await auth.actions.popupLogin({
                    email: auth.userEmail,
                })
            }}
        >
            {() => (
                <AuthLoginConfirm auth={auth} />
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(AuthLoginConfirmModal)
